import { render, staticRenderFns } from "./SfLoader.vue?vue&type=template&id=fc220c12&functional=true"
import script from "./SfLoader.vue?vue&type=script&lang=js"
export * from "./SfLoader.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfLoader.vue?vue&type=style&index=0&id=fc220c12&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "2766ae87"
  
)

export default component.exports